import { EntityModel } from '@/interfaces'
import {
  ALL_TENANT_SETTINGS_QUERY,
  CREATE_TENANT_SETTINGS_MUTATION,
  DELETE_TENANT_SETTINGS_MUTATION,
  FORCE_DELETE_TENANT_SETTINGS_MUTATION,
  SINGLE_TENANT_SETTINGS_QUERY,
  UPDATE_TENANT_SETTINGS_MUTATION,
} from './graphql'
import tenantEntity from '@/entities/tenant/entity'
import travelTypeEntity from '@/entities/travelType/entity'

const travelObjectTenantSettingsModel: EntityModel = {
  name: 'tenantSettings',
  namePlural: 'tenantSettings',
  uniqueName: 'travelObjectTenantSettings',
  uniqueNamePlural: 'travelObjectTenantSettings',
  path: 'travel/tenant_settings',
  baseUrl: '/travel/tenant_settings',
  translationPrefix: 'entities:travelObjectTenantSettings.',
  getDisplayName: (values: any) => {
    return 'Travel Tenant Settings'
  },
  gql: {
    getAll: ALL_TENANT_SETTINGS_QUERY,
    getSingle: SINGLE_TENANT_SETTINGS_QUERY,
    create: CREATE_TENANT_SETTINGS_MUTATION,
    update: UPDATE_TENANT_SETTINGS_MUTATION,
    delete: DELETE_TENANT_SETTINGS_MUTATION,
    forceDelete: FORCE_DELETE_TENANT_SETTINGS_MUTATION,
  },
  attributes: {
    tenant: {
      name: 'tenant',
      label: 'entities:travelObjectTenantSettings.attributes.tenant.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return tenantEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    onlineStatus: {
      name: 'onlineStatus',
      label: 'entities:travelObjectTenantSettings.attributes.onlineStatus.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:travelObjectTenantSettings.attributes.onlineStatus.selectOptions.OFFLINE.label',
          value: 'OFFLINE',
        },
        {
          label: 'entities:travelObjectTenantSettings.attributes.onlineStatus.selectOptions.ONLINE.label',
          value: 'ONLINE',
        },
        {
          label: 'entities:travelObjectTenantSettings.attributes.onlineStatus.selectOptions.HIDDEN.label',
          value: 'HIDDEN',
        },
      ],
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    redirectToBooking: {
      name: 'redirectToBooking',
      label: 'entities:travelObjectTenantSettings.attributes.redirectToBooking.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    useTiming: {
      name: 'useTiming',
      label: 'entities:travelObjectTenantSettings.attributes.useTiming.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    startDate: {
      name: 'startDate',
      label: 'entities:travelObjectTenantSettings.attributes.startDate.label',
      type: 'value',
      dataType: 'Date',
      defaultInput: true,
      inputType: 'text',
      isStartDate: true,
      endDateAttribute: 'endDate',
      validationType: 'string',
      validations: [],
    },
    endDate: {
      name: 'endDate',
      label: 'entities:travelObjectTenantSettings.attributes.endDate.label',
      type: 'value',
      dataType: 'Date',
      defaultInput: true,
      inputType: 'text',
      isEndDate: true,
      startDateAttribute: 'startDate',
      validationType: 'string',
      validations: [],
    },
    travelTypes: {
      name: 'travelTypes',
      label: 'entities:travelObjectTenantSettings.attributes.travelTypes.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return travelTypeEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelObjectTenantSettingsModel
